import "./Directory.css"
import Footer from "../../Components/Footer/Footer";
import { useEffect, useState, useRef, useContext } from "react";
import {Card} from '@nxtvid/component-library';
import { checkImgSrc } from "../../Utilities/checkImgSrc";
import trackPageView from "../../Utilities/trackPageView";
import { UserContext } from "../../Contexts/UserContext";
import { AuthContext } from "../../Contexts/AuthContext";
import { SearchVectorContext } from "../../Contexts/SearchVectorContext";
import { UserQueryContext } from "../../Contexts/UserQueryContext";
import { SearchVectorLoadingContext } from "../../Contexts/SearchVectorLoadingContext";
import { SelectedCategoryContext } from "../../Contexts/SelectedCategoryContext";
import { SelectedCityContext } from "../../Contexts/SelectedCityContext";
import { SelectedBudgetContext } from "../../Contexts/SelectedBudgetContext";
import { SignUpInfoContext } from "../../Contexts/SignUpInfoContext";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
const API_SECRET = process.env.REACT_APP_NXTVID_API_SECRET;

const Directory = () =>{
  
  const filterIcon = require('../../Images/Filter.png')
  const searchButtonIcon = require('../../Images/SearchButton.png')  
  const greyCarrot = require('../../Images/greyCarrot.png')
  const categories = ["None", "Event",'Food & Beverage', "Product"]
  const cities = ["None", "Miami",'New York', "Los Angeles"]
  const pricingTiers = ["None", "Value",'Mid-Range', "High-End"]
  const [page, setPage] = useState(0)
  const [loadingMore, setLoadingMore] = useState(false)
  const [allLoaded, setAllLoaded] = useState(false)
  const logoUrlsRef = useRef({}); // Store fetched logo URLs without causing re-renders
  const thumbnailUrlsRef = useRef({}); // Store fetched thumbnail URLs without causing re-renders

  const [currentIndex, setCurrentIndex] = useState(0);
  const [triggerAutoPlay, setTriggerAutoPlay] = useState(false);
    const [gridData, setGridData] = useState([]);
    const randomSeed = Math.random();
    const [selectedVideo, setSelectedVideo] = useState({
        listingId: "1a2b3c",
        beginTimeStamp: 1609459200, // Equivalent to Jan 1, 2021
        endTimeStamp: 1609462800, // Equivalent to Jan 1, 2021, 1 hour later
        videoLink: "https://example.com/video1.mp4",
        thumbnailLink: "https://via.placeholder.com/", // Placeholder thumbnail image
        tags: ["nature", "wildlife", "forest"]
      });
    const [isCardVisible, setIsCardVisible] = useState(false)
    const [records, setRecords] = useState([{companyName:'', listingInfo:{companyName:''},listingId: "1a2b3c",
      beginTimeStamp: 1609459200, // Equivalent to Jan 1, 2021
      endTimeStamp: 1609462800, // Equivalent to Jan 1, 2021, 1 hour later
      videoLink: "https://example.com/video1.mp4",
      thumbnailLink: "https://via.placeholder.com/", // Placeholder thumbnail image
      tags: ["nature", "wildlife", "forest"]},{companyName:'', listingInfo:{companyName:''},listingId: "1a2b3c",
      beginTimeStamp: 1609459200, // Equivalent to Jan 1, 2021
      endTimeStamp: 1609462800, // Equivalent to Jan 1, 2021, 1 hour later
      videoLink: "https://example.com/video1.mp4",
      thumbnailLink: "https://via.placeholder.com/", // Placeholder thumbnail image
      tags: ["nature", "wildlife", "forest"]}, {companyName:'', listingInfo:{companyName:''}}, {companyName:'', listingInfo:{companyName:''},listingId: "1a2b3c",
      beginTimeStamp: 1609459200, // Equivalent to Jan 1, 2021
      endTimeStamp: 1609462800, // Equivalent to Jan 1, 2021, 1 hour later
      videoLink: "https://example.com/video1.mp4",
      thumbnailLink: "https://via.placeholder.com/", // Placeholder thumbnail image
      tags: ["nature", "wildlife", "forest"]},{companyName:'', listingInfo:{companyName:''}}, {companyName:'', listingInfo:{companyName:''},
      listingId: "1a2b3c",
      beginTimeStamp: 1609459200, // Equivalent to Jan 1, 2021
      endTimeStamp: 1609462800, // Equivalent to Jan 1, 2021, 1 hour later
      videoLink: "https://example.com/video1.mp4",
      thumbnailLink: "https://via.placeholder.com/", // Placeholder thumbnail image
      tags: ["nature", "wildlife", "forest"]}, {companyName:'', listingInfo:{companyName:''},listingId: "1a2b3c",
      beginTimeStamp: 1609459200, // Equivalent to Jan 1, 2021
      endTimeStamp: 1609462800, // Equivalent to Jan 1, 2021, 1 hour later
      videoLink: "https://example.com/video1.mp4",
      thumbnailLink: "https://via.placeholder.com/", // Placeholder thumbnail image
      tags: ["nature", "wildlife", "forest"]}, {companyName:'', listingInfo:{companyName:''},listingId: "1a2b3c",
      beginTimeStamp: 1609459200, // Equivalent to Jan 1, 2021
      endTimeStamp: 1609462800, // Equivalent to Jan 1, 2021, 1 hour later
      videoLink: "https://example.com/video1.mp4",
      thumbnailLink: "https://via.placeholder.com/", // Placeholder thumbnail image
      tags: ["nature", "wildlife", "forest"]}, {companyName:'', listingInfo:{companyName:''},listingId: "1a2b3c",
      beginTimeStamp: 1609459200, // Equivalent to Jan 1, 2021
      endTimeStamp: 1609462800, // Equivalent to Jan 1, 2021, 1 hour later
      videoLink: "https://example.com/video1.mp4",
      thumbnailLink: "https://via.placeholder.com/", // Placeholder thumbnail image
      tags: ["nature", "wildlife", "forest"]}])
    const [recordIds, setRecordIds] = useState([])
    const [filterChange, setFilterChange] = useState(false)
    const videoCardRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const currentGridItemRef = useRef(null);
    const { userInfo, setUserInfo} = useContext(UserContext);
    const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);
    const { searchVector, setSearchVector } = useContext(SearchVectorContext);
    const {userQuery, setUserQuery} = useContext(UserQueryContext);
    const {searchVectorLoading, setSearchVectorLoading} = useContext(SearchVectorLoadingContext)
    const {selectedCategory, setSelectedCategory} = useContext(SelectedCategoryContext)
    const {selectedCity, setSelectedCity} = useContext(SelectedCityContext)
    const {selectedBudget, setSelectedBudget} = useContext(SelectedBudgetContext)
    const {signUpInfo, setSignUpInfo} = useContext(SignUpInfoContext);

  //mixpanel page tracking
  useEffect(() => {
    console.log(`userInfo`, userInfo);
    const cleanup = trackPageView(userInfo, "Directory"); // Track page view and get cleanup function

    return () => {
      cleanup(); // Call the cleanup function when the component unmounts
    };
  }, [userInfo]);
  
  // Get selected category from session storage on component mount and set it
  useEffect(() => {
    const savedCategory = sessionStorage.getItem('selectedCategory');
    if (savedCategory) {
      setSelectedCategory(savedCategory);
      setPage(0); // Reset page number
      sessionStorage.removeItem('selectedCategory'); // Clear after reading
    }
  }, []);

  // Get user query from session storage on component mount
  useEffect(() => {
    const savedUserQuery = sessionStorage.getItem('userQuery');
    if (savedUserQuery) {
      console.log(`savedUserQuery`, savedUserQuery);
      setUserQuery(savedUserQuery);
  
      // Pass the saved query directly
      setTimeout(() => {
        handleSubmit(savedUserQuery);
        sessionStorage.removeItem('userQuery');
      }, 1000);
    }
  }, []);
  
  


    useEffect(() => {
    

    const isPortrait = window.matchMedia("(orientation: portrait)").matches;

  if (!isPortrait) {
    console.log("Skipping intersection logic as the device is not in portrait mode.");
    return;
  }
  
  if(videoCardRef.current !== null && document.getElementsByClassName('grid-item')[0] !== undefined){
  videoCardRef.current.style.top = document.getElementsByClassName('grid-item')[0].getBoundingClientRect().top + 'px';
  videoCardRef.current.style.left = document.getElementsByClassName('grid-item')[0].getBoundingClientRect().left + 'px';
  }

  
      

  const handleIntersection = (entries) => {
    const gridDataMap = new Map(gridData.map(item => [item._id, item])); // Fast lookups
  
    entries.forEach(entry => {
      if (!entry.isIntersecting) return; // Skip non-intersecting entries
  
      const gridItem = entry.target;
      const gridItemId = gridItem.dataset.id;
      const gridItemData = gridDataMap.get(gridItemId); // Direct access instead of .find()
  
      if (gridItemData) {
        currentGridItemRef.current = gridItem; // Store the intersecting element
  
        if (!selectedVideo || selectedVideo._id !== gridItemData._id) {
          setSelectedVideo(gridItemData);
          setCurrentIndex(gridItemData._id); // Update currentIndex to the new ID
        }
      } else {
        console.warn(`No matching grid item data found for id: ${gridItemId}`);
      }
    });
  };
  

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 1.0 
    });

    const gridItems = document.querySelectorAll('.grid-item');
    gridItems.forEach(item => {
      observer.observe(item);
    });

    const handleScroll = () => {
      const videoCard = videoCardRef.current;
      const currentGridItem = currentGridItemRef.current;
      
    
      if (videoCard && currentGridItem) {
        // Append videoCard to currentGridItem if not already appended
        if (videoCard.parentNode !== currentGridItem) {
          currentGridItem.appendChild(videoCard);
        }
    
        // Set videoCard position to be relative to currentGridItem
        videoCard.style.position = 'absolute';
        videoCard.style.top = '0';
        videoCard.style.left = '0';
        videoCard.style.width = '100%';
        videoCard.style.height = '100%';
        videoCard.style.zIndex = '1'; // Ensure it is above other content
        videoCard.style.display = 'flex';
    
       
      } else {
        console.log('No currentGridItem or videoCard');
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    setTriggerAutoPlay(true);
    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', handleScroll);
    };
  }, [gridData, selectedVideo, userQuery]);

  useEffect(() => {
    const checkOrientation = () => {
      if (window.matchMedia("(orientation: portrait)").matches) {
        setIsCardVisible(true);
        
      } else {
        setIsCardVisible(false);
      }
    };
    

    checkOrientation(); // Initial check
    window.addEventListener('resize', checkOrientation); // Check on resize

    return () => {
      window.removeEventListener('resize', checkOrientation);
    };
  }, []);

  useEffect(() => { 
    if (triggerAutoPlay===true) {
      setTimeout(() => {
        window.scrollTo({
          top: window.scrollY+1, // Adjust this value to your desired scroll position
          behavior: 'smooth' // Optional: for smooth scrolling
        });
      }, 1000);
    }
  }, [triggerAutoPlay]);

      function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [array[i], array[j]] = [array[j], array[i]]; // Swap elements
        }
        return array;
      }

      const handleSubmit = async (query) => {
        setIsLoading(true)
        setRecords([{companyName:'', listingInfo:{companyName:''}},{companyName:'', listingInfo:{companyName:''}}, {companyName:'', listingInfo:{companyName:''}}, {companyName:'', listingInfo:{companyName:''}},{companyName:'', listingInfo:{companyName:''}}, {companyName:'', listingInfo:{companyName:''}}, {companyName:'', listingInfo:{companyName:''}}, {companyName:'', listingInfo:{companyName:''}}, {companyName:'', listingInfo:{companyName:''}}])
        setFilterChange(true);
        setAllLoaded(false)
        setRecordIds([])
        window.scrollTo(0, 0);
        try {
            setSearchVectorLoading(true)
          const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
          const response = await fetch(`${API_BASE_URL}/api/vectorizeUserQuery`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({ searchQuery: query }),
          });if (!response.ok) {
            throw new Error(`Error: ${response.status}`); 
          }
          const jsonResponse = await response.json(); 
          setSearchVector(jsonResponse)
          setSearchVectorLoading(false)
        } catch (error) {
          console.error("Error fetching vectorized query:", error); 
          setSearchVectorLoading(false)
          setSearchVector(null)
          getVideoClips()
        }
      };

      const getVideoClips = async() =>{
        if(filterChange){
          setAllLoaded(false)
          setFilterChange(false)
          setPage(0); 
          setRecords([]);
          setRecordIds([]);
          setGridData([]);
          window.scrollTo(0, 0);
        }
      
        const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
        let category = selectedCategory === 'None' ? null : selectedCategory
        let city = selectedCity === 'None' ? null : selectedCity
        let budget = selectedBudget === 'None' ? null : selectedBudget

        if(searchVector && !searchVectorLoading){
          const response = await fetch(`${API_BASE_URL}/api/get-video-clips`,{
            method:'POST',
            headers: { 
              'Content-Type': 'application/json',
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET, },
            body: JSON.stringify({ searchVector, category, city, budget, page, randomSeed, recordIds })
          })
          const data = await response.json()
   
          if (data.length === 0) {
            setAllLoaded(true);
          } else {
      
            setRecords((prevRecords) => {
              const uniqueRecords = new Map(prevRecords.map(record => [record._id, record]));
              data.forEach(record => uniqueRecords.set(record._id, record));
              const newRecords = Array.from(uniqueRecords.values());
              const newRecordIds = newRecords.map(record => record._id);
              setRecordIds(newRecordIds);
              data.forEach(record => uniqueRecords.set(record._id, record));
              return Array.from(uniqueRecords.values());
              
            });
          }
          setLoadingMore(false);
          setIsLoading(false)
          return
        }

        else if(searchVectorLoading){
          return
        }

        else{
          const response = await fetch(`${API_BASE_URL}/api/get-video-clips`,{
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
             },
            body: JSON.stringify({ category, city, budget, page, randomSeed })
          })
          const data = await response.json()
          if (data.length === 0) {
            setAllLoaded(true);
          } else {
     
            setRecords((prevRecords) => {
              const uniqueRecords = new Map(prevRecords.map(record => [record._id, record]));
              data.forEach(record => uniqueRecords.set(record._id, record));
              return Array.from(uniqueRecords.values());
            }); 
          }
          setLoadingMore(false);
          setIsLoading(false)
        }
      }

      useEffect(()=>{
        getVideoClips()
      },[searchVector, selectedBudget, selectedCategory, selectedCity])

      
    
    useEffect(() => {
      const handleScroll = () => {
        if (
          window.innerHeight + document.documentElement.scrollTop >=
            document.documentElement.offsetHeight - 650 &&
          !loadingMore &&
          !allLoaded
        ) {
          setLoadingMore(true);
          setPage((prevPage) => prevPage + 1);
        }
      };
    
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }, [loadingMore, allLoaded]);

    useEffect(() => {
      if (page > 0) {
        getVideoClips();
      }
    }, [page]);

    useEffect(() => {
      if (!records.length) return;
  
      const fetchSignedUrl = async (endpoint, filePath) => {
        try {
          const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-SECRET": API_SECRET,
            },
            body: JSON.stringify({ filePath }),
          });
          const data = await response.json();
          return response.ok ? data.signedUrl : null;
        } catch (error) {
          console.error(`Error fetching signed URL (${endpoint}):`, error);
          return null;
        }
      };
  
      const fetchUrlsForBatch = async () => {
        const newGridItems = await Promise.all(
          records.map(async (record) => {
            const id = record._id; // Ensure each record has a unique ID
  
            // Fetch and store logo URL if not already in ref
            if (record?.listingInfo?.companyLogo && !logoUrlsRef.current[id]) {
              const filePath = record.listingInfo.companyLogo.split("/").pop();
              logoUrlsRef.current[id] = await fetchSignedUrl(
                "get-logo-about-image",
                filePath
              );
            }
  
            // Fetch and store thumbnail URL if not already in ref
            if (record?.thumbnailLink && !thumbnailUrlsRef.current[id]) {
              const fileName = record.thumbnailLink.split("/").pop();
              const filePath = `thumbnails/${fileName}`;
              thumbnailUrlsRef.current[id] = await fetchSignedUrl(
                "get-thumbnail",
                filePath
              );
            }
  
            return {
              ...record,
              logoUrl: logoUrlsRef.current[id] || null,
              thumbnailUrl: thumbnailUrlsRef.current[id] || null,
            };
          })
        );
  
        // Append new batch instead of replacing the whole grid
        setGridData((prev) => [...prev, ...newGridItems]);
      };
  
      fetchUrlsForBatch();
    }, [records]);
    

    
      

      const handleClick = (record) => {
        
        
        if (window.matchMedia("(orientation: portrait)").matches) {
          console.log("Skipping click event as the device is in portrait mode.");
          return null
        };
        setIsCardVisible(true)
        setSelectedVideo(record); // Set the selected video info
      };

      const handleNextVideo = (direction) => {
        if (!selectedVideo) return; // Prevent errors if no video is selected
      
        // Create a Map of _id → index for fast lookup
        const gridDataMap = new Map(records.map((record, index) => [record._id, index]));
      
        const currentIndex = gridDataMap.get(selectedVideo._id); // O(1) lookup
      
        if (currentIndex === undefined) return; // Edge case: ID not found
      
        let newIndex = direction === "right" ? currentIndex + 1 : currentIndex - 1;
      
        // Ensure new index is within bounds
        if (newIndex >= 0 && newIndex < records.length) {
          const newVideo = records[newIndex];
      
          if (newVideo && newVideo.companyName !== "") {
            setSelectedVideo(newVideo); // Update selected video
            setCurrentIndex(newVideo._id); // Store _id instead of index
      
            // If at the last item, fetch more data
            if (direction === "right" && newIndex === records.length - 1) {
              setPage((prevPage) => prevPage + 1);
            }
          }
        }
      };
      

      const handleGoToPortfolio = async(companyUrl) =>{
        window.location.assign(`/Portfolios/${companyUrl}`)
      }

      const VideoCard = () => {
        console.log(`selectedVideo`, selectedVideo);
        const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
        const [videoSrc, setVideoSrc] = useState(null);
        const [isMetadataLoaded, setIsMetadataLoaded] = useState(false);
        const videoRef = useRef(null);
    
        const startTime = selectedVideo?.beginTimeStamp ? selectedVideo.beginTimeStamp / 10 : 0;
        let endTime = selectedVideo?.endTimeStamp ? selectedVideo.endTimeStamp / 10 : 0;
        if (endTime - startTime < 3) {
            endTime = startTime + 3;
        }
        const fileName = selectedVideo?.videoLink ? selectedVideo.videoLink.split("/").pop() : "";
    
        useEffect(() => {
            // Fetch the signed URL
            const fetchSignedUrl = async () => {
                try {
                  const response = await fetch(`${API_BASE_URL}/get-signed-url-video`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET, // Securely pass the secret
                    },
                    body: JSON.stringify({ filePath: fileName }),
                  });
                    const data = await response.json();
                    setVideoSrc(data.url);
                } catch (error) {
                    console.error("Error fetching signed URL:", error);
                }
            };
            fetchSignedUrl();
        }, [fileName]);

        useEffect(() => {
          const video = videoRef.current;
      
          if (video) {
              const enforceStartTime = () => {
                  if (video.currentTime !== startTime) {
                      video.currentTime = startTime;
                  }
              };
      
              video.addEventListener("play", enforceStartTime);
      
              return () => {
                  video.removeEventListener("play", enforceStartTime);
              };
          }
      }, [startTime]);
      
    
        useEffect(() => {
            const video = videoRef.current;
    
            if (video && videoSrc) {
                const handleMetadataLoaded = () => {
                    setIsMetadataLoaded(true);
                    video.currentTime = startTime;
                    video.play().catch((err) => console.warn("Play failed:", err));
                };
    
                const handleTimeUpdate = () => {
                    if (video.currentTime >= endTime) {
                        video.pause();
                        video.currentTime = startTime;
                        video.play().catch((err) => console.warn("Play failed:", err));
                    }
                };
    
                video.addEventListener("loadedmetadata", handleMetadataLoaded);
                video.addEventListener("timeupdate", handleTimeUpdate);
    
                return () => {
                    video.removeEventListener("loadedmetadata", handleMetadataLoaded);
                    video.removeEventListener("timeupdate", handleTimeUpdate);
                };
            }
        }, [videoSrc, startTime, endTime]);
    
        return (
            <div
                className="background-shade"
                onClick={() => {
                    if (window.matchMedia("(orientation: portrait)").matches) {
                        console.log("Skipping click event as the device is in portrait mode.");
                        setIsCardVisible(true);
                        return null;
                    }
                    else{
                      console.log("Click event triggered");
                        setIsCardVisible(false);
                    }
                    
                }}
            >
                <div
                    className={`Video-Card`}
                    ref={videoCardRef}
                >
                    <video
                        ref={videoRef}
                        id="Video-Player"
                        playsInline
                        muted
                        className="video-player"
                        preload="metadata"
                        autoPlay
                        src={videoSrc}
                        
                    />
                    <div
                        className="rightButton"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleNextVideo("right");
                        }}
                    >
                        <img src={greyCarrot} alt="Next" />
                    </div>
                    <div
                        className="leftButton"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleNextVideo("left");
                        }}
                    >
                        <img src={greyCarrot} alt="Previous" />
                    </div>
                    <div
                        className="company-logo-card"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleGoToPortfolio(selectedVideo.listingInfo.companyUrl);
                        }}
                    >
                        <img
                            className="logo-img-card"
                            alt={`${selectedVideo?.listingInfo?.companyName ? selectedVideo?.listingInfo?.companyName : 'No'}'s Logo`}
                            src={logoUrlsRef ? logoUrlsRef.current[currentIndex] : ""}
                        />
                    </div>
                    <p
                        className="company-name-card"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleGoToPortfolio(selectedVideo?.listingInfo?.companyUrl ? selectedVideo?.listingInfo?.companyUrl : "");
                        }}
                    >
                        {selectedVideo?.listingInfo?.companyName ? selectedVideo?.listingInfo?.companyName : "No Company Name"}
                    </p>
                </div>
            </div>
        );
    };
    
    

      const Grid = ({ records }) =>{
        
        records = records.filter(record => record?.companyName != null);

        return (
            <div className="grid-container">
              {records.map((record, index) => {
                if(isLoading){
                  return(<Card 
                  isLoading={true}
                  size="large"
                  key={index}
                    id={record._id}
                  children ={
                    <div
                    
                    className={`grid-item ${record.isTall ? 'tall' : ''}`}
                       />
                  }
                  />)
                }
                
                else{
                  let isValidSrc = true;
                  checkImgSrc(thumbnailUrlsRef.current[record._id]).then(isValid => { isValidSrc = isValid});
                  if (record.companyName === '') return
                  return(<Card 
                    key={index}
                    id={record._id}
                    size="large"
                    backgroundImgSrc={thumbnailUrlsRef.current[record._id]}
                    backgroundImgSrcOnError = {logoUrlsRef.current[record._id]}
                    className={`grid-item ${record.isTall ? 'tall' : ''}`}
                    onClick={() => {console.log('clicked');if(!window.matchMedia("(orientation: portrait)").matches){setCurrentIndex(record._id);handleClick(record)}}}
                    children ={
                        <div className="hover-details" data-key={index}>
                       <div className='company-logo-directory' data-key={index}>
                         {record.listingInfo? <img className='logo-img-directory' alt={`${record.listingInfo.companyName}'s Logo`} src={record.listingInfo ? logoUrlsRef.current[record._id]:''}/>: null}
                        </div>
                        <p className='company-name' data-key={index}>{record.listingInfo.companyName}</p>
                        <div className='play-button' data-key={index} >
                         <p data-key={index}>⏵</p>
                        </div>
                     </div>
                    }
                    />)
                }
                })}
            </div>
          );

    }
    
    
    return(
        <div>
                <div className="App-body-directory" >
                <div className="background-shades" onClick={(e)=>{e.target.style.display='none'; document.getElementsByClassName("sign-in-card")[0].style.display='none'; document.getElementsByClassName("sign-up-card")[0].style.display='none'; document.getElementsByClassName("forgot-password-card")[0].style.display='none';document.getElementsByClassName("purchase-tokens-card")[0].style.display='none'; document.getElementsByClassName('sign-in-notification-message')[0].innerHTML=''; document.getElementsByClassName('sign-up-notification-message')[0].innerHTML=''; }}/>
                {isCardVisible ? <VideoCard /> : <></>}
                <h2 className="directory-header">{`Video Project Inspiration by NXTVid Videographers`}</h2>
                <Grid records={gridData}/>
                <div className="Floating-Directory-Menu">
                  <div className="filters">
                    <div className="filterIcon">
                      <img src={filterIcon} alt="Filter Button"/>
                      <div className="filter-dropdown">
                        <div className="category-dropdown-mobile">
                          <p className="directory-menu-item">{selectedCategory !== "None" ? selectedCategory : 'Category'}<img className="mobile-arrow" src={greyCarrot}/></p>
                          <div>
                            {categories.map((category) => (<p id={category} onClick={(e)=>{setFilterChange(true);setSelectedCategory(e.target.id)}}> {category}</p>))}
                          </div>
                        </div>
                        <div className="city-dropdown-mobile">
                          <p className="directory-menu-item">{selectedCity !== "None" ? selectedCity : 'City'}<img className="mobile-arrow" src={greyCarrot}/></p>
                          <div>
                            {cities.map((city) => (<p id={city} onClick={(e)=>{setFilterChange(true);setSelectedCity(e.target.id)}}>{city}</p>))}
                          </div>
                        </div>
                        <div className="budget-dropdown-mobile">
                          <p className="directory-menu-item">{selectedBudget !== "None" ? selectedBudget : 'Budget'}<img className="mobile-arrow" src={greyCarrot}/></p>
                          <div>
                              {pricingTiers.map((pricingTier) => (<p id={pricingTier} onClick={(e)=>{setFilterChange(true);setSelectedBudget(e.target.id)}}>{pricingTier}</p>))}
                            </div>
                          </div>
                      </div>
                    </div>
                  <div className='category-dropdown'>
                    <p className="directory-menu-item">{selectedCategory !== "None" ? selectedCategory : 'Category'}<img className="grey-carrot-directory" src={greyCarrot}/></p>
                    
                    <div>
                      {categories.map((category) => (<p id={category} onClick={(e)=>{setFilterChange(true);setSelectedCategory(e.target.id)}}> {category}</p>))}
                    </div>
                  </div>
                  <div className='city-dropdown'>
                    <p className="directory-menu-item">{selectedCity !== "None" ? selectedCity : 'City'}<img className="grey-carrot-directory" src={greyCarrot}/></p>
                    <div>
                      {cities.map((city) => (<p id={city} onClick={(e)=>{setFilterChange(true);setSelectedCity(e.target.id)}}>{city}</p>))}
                    </div>
                  </div>
                  <div className='budget-dropdown'>
                  <p className="directory-menu-item">{selectedBudget !== "None" ? selectedBudget : 'Budget'}<img className="grey-carrot-directory" src={greyCarrot}/></p>
                  <div>
                      {pricingTiers.map((pricingTier) => (<p id={pricingTier} onClick={(e)=>{setFilterChange(true);setSelectedBudget(e.target.id)}}>{pricingTier}</p>))}
                    </div>
                  </div>
                  </div>
                  
                  
                <div className="MainSearchBar-Directory directory-menu-item">
                    <input className="userQueryInput" type="text" placeholder="What do you want to create?" value={userQuery} onChange={(e)=>{setUserQuery(e.target.value)}}/>
                    
                    <div className="searchButton-directory" onClick={()=>handleSubmit(userQuery)}>
                        <img alt="Search Button" className="search-button-icon" src={searchButtonIcon}/>
                    </div>
                </div>
                </div>
                </div>
        </div>
    )
}

export default Directory